import { Link } from "react-router-dom";
import styles from "./WhatsappButton.module.scss";

const WhatsappButton = () => {
  return (
    <Link
      className={styles.whatsappButton}
      to="https://api.whatsapp.com/send?phone=6281188030203&amp;text=Halo%20Admin%2C%20saya%20sedang%20membutuhkan%20jasa%20perpajakan.%20Apakah%20boleh%20dibantu%3F"
      //   href="https://api.whatsapp.com/send?phone=6281321111423&amp;text=Halo%20Admin%2C%20saya%20ingin%20mengetahui%20informasi%20lebih%20lanjut%20tentang%20"
      target="_blank"
      rel="noreferrer"
    >
      <i class="uil uil-whatsapp" />
    </Link>
  );
};

export default WhatsappButton;
